import { Grid, Typography } from '@material-ui/core'
import React from 'react'

export const HeaderInfo = ({ label = '', info = '' }) => {
  return (
    <Grid container spacing={1}>
      <Grid item>
        <Typography style={{ fontWeight: 'bold' }}>{label}</Typography>
      </Grid>
      <Grid item>
        <Typography>{info}</Typography>
      </Grid>
    </Grid>
  )
}
